import { JoinConference } from 'domain/usecases/conference/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteJoinConference implements JoinConference {
  private readonly url: string;

  private readonly httpClient: HttpClient<JoinConference.Model>;

  constructor(url: string, httClient: HttpClient<JoinConference.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  join = async (
    params: JoinConference.Params,
  ): Promise<JoinConference.Model> => {
    let query = '';

    if (params.userLocator?.length)
      query += `?userLocator=${params.userLocator}`;

    const httpResponse = await this.httpClient.request({
      url:
        this.url.replace('{conferenceShort}', `${params.conferenceShort}`) +
        query,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
